import React from "react";
import { MdLockOutline, MdPersonAdd } from "react-icons/md";
import Button from "components/button";
import { InputField } from "components/fields";

/**
 * First screen of the heartbeat survey: welcome copy, optional contact details
 * (general and spiritual surveys), privacy note (spiritual) and the start button.
 */
const SurveyWelcome = ({
  campaign,
  isPathwaysSurvey,
  visitorName,
  contact,
  onContactChange,
  showContactFields,
  onShowContactFields,
  starting,
  onStart,
}) => {
  const updateContact = (field) => (e) => onContactChange(field, e.target.value);

  return (
    <>
      <h1 className="text-center text-title">
        {isPathwaysSurvey && visitorName
          ? `Welcome, ${visitorName}`
          : campaign?.welcomeMessage || "Welcome"}
      </h1>
      <p className="mt-2 text-center text-sm text-fg-muted">
        {isPathwaysSurvey
          ? "We'd love to hear about your experience. Just 5 quick questions."
          : campaign?.surveyDescription || "We'd love to hear from you."}
      </p>

      {!isPathwaysSurvey && (
        <section className="mt-8" aria-labelledby="survey-contact-heading">
          <h2 id="survey-contact-heading" className="text-sm font-medium text-fg">
            {showContactFields ? "Tell Us About Yourself" : "What's Your Name?"}
          </h2>

          {showContactFields ? (
            <div className="mt-3 flex flex-col gap-3">
              <div className="grid grid-cols-2 gap-3">
                <InputField
                  label="First Name"
                  name="given-name"
                  autoComplete="given-name"
                  value={contact.firstName}
                  onChange={updateContact("firstName")}
                  autoFocus
                />
                <InputField
                  label="Last Name"
                  name="family-name"
                  autoComplete="family-name"
                  value={contact.lastName}
                  onChange={updateContact("lastName")}
                />
              </div>
              <InputField
                label="Email"
                type="email"
                name="email"
                autoComplete="email"
                value={contact.email}
                onChange={updateContact("email")}
              />
              <InputField
                label="Phone"
                type="tel"
                name="tel"
                autoComplete="tel"
                value={contact.phone}
                onChange={updateContact("phone")}
                hint="All fields are optional. Share what you're comfortable with."
              />
            </div>
          ) : (
            <>
              <Button
                variant="secondary"
                size="lg"
                fullWidth
                leftIcon={<MdPersonAdd aria-hidden="true" className="h-5 w-5" />}
                onClick={onShowContactFields}
                className="mt-3"
              >
                Add Your Info (Optional)
              </Button>
              <p className="mt-2 text-xs text-fg-muted">This helps us personalize your experience.</p>
            </>
          )}
        </section>
      )}

      {campaign?.surveyType === "spiritual" && (
        <div className="mt-6 flex items-start gap-3 rounded-control bg-surface-raised p-4">
          <MdLockOutline aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-primary dark:text-accent" />
          <p className="text-xs leading-relaxed text-fg-muted">
            Your responses are confidential and will only be shared with our pastoral care team to
            help us better support you on your spiritual journey.
          </p>
        </div>
      )}

      <Button size="lg" fullWidth loading={starting} onClick={onStart} className="mt-8">
        {starting ? "Starting…" : "Begin Survey"}
      </Button>

      <p className="mt-6 text-center text-xs text-fg-muted">This survey takes about 2-3 minutes.</p>
    </>
  );
};

export default SurveyWelcome;
